import React from 'react'

function LinkedInSvg() {
  return (
    <>
      <svg
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='16' cy='16' r='15.5' fill='white' stroke='#D1DEEE' />
        <path
          d='M10.8968 9C9.85088 9 9 9.84996 9 10.8947C9 11.9399 9.85088 12.7902 10.8968 12.7902C11.9418 12.7902 12.792 11.9398 12.792 10.8947C12.7921 9.84996 11.9418 9 10.8968 9Z'
          fill='#0E1F33'
        />
        <path
          d='M12.3329 13.5723H9.45848C9.33091 13.5723 9.22754 13.6757 9.22754 13.8032V23.0375C9.22754 23.1651 9.33091 23.2685 9.45848 23.2685H12.3329C12.4605 23.2685 12.5639 23.1651 12.5639 23.0375V13.8032C12.5639 13.6757 12.4605 13.5723 12.3329 13.5723Z'
          fill='#0E1F33'
        />
        <path
          d='M19.3261 13.3428C18.1716 13.3428 17.3182 13.8391 16.8006 14.403V13.8032C16.8006 13.6757 16.6972 13.5723 16.5697 13.5723H13.8169C13.6893 13.5723 13.5859 13.6757 13.5859 13.8032V23.0375C13.5859 23.1651 13.6893 23.2685 13.8169 23.2685H16.685C16.8126 23.2685 16.916 23.1651 16.916 23.0375V18.4687C16.916 16.9291 17.3342 16.3293 18.4074 16.3293C19.5762 16.3293 19.6691 17.2909 19.6691 18.5479V23.0376C19.6691 23.1652 19.7725 23.2685 19.9001 23.2685H22.7693C22.8968 23.2685 23.0002 23.1652 23.0002 23.0376V17.9724C23.0002 15.6831 22.5637 13.3428 19.3261 13.3428Z'
          fill='#0E1F33'
        />
      </svg>
    </>
  )
}

export default LinkedInSvg
